// useFetchTvChannelPackages.js
import axios from "axios";
import useGetImages from "./useGetImages";

const useGetTvChannelPackages = () => {
  // Hooks
  const { getImages } = useGetImages();

  const getTvChannelPackages = async (tvChannels) => {
    try {
      const response = await axios.get(
        window.location.origin +
          "/wp-json/wp/v2/produkter/tv_kanal_paket?_fields=title,acf,id,type,slug,featured_media&orderby=menu_order&order=asc&per_page=50"
      );

      // Extracting data from response
      const data = response.data;

      // Fetching images
      const imageArray = await getImages(data);

      // Remapping object
      const tvChannelPackages = [
        ...data.map((tvChannelPackage, index) => ({
          id: tvChannelPackage.id,
          slug: tvChannelPackage.slug,
          type: tvChannelPackage.title.rendered === "Baspaket" ? "tv_kanal_bas_paket" : tvChannelPackage.type,
          title: tvChannelPackage.title.rendered,
          image: imageArray[index],
          description: tvChannelPackage.acf.beskrivning,
          price: tvChannelPackage.acf.pris,
          monthly_price: tvChannelPackage.acf.manadspris,
          discount_price: tvChannelPackage.acf.kampanj_pris !== "" ? tvChannelPackage.acf.kampanj_pris : null,
          discount_terms: tvChannelPackage.acf.kampanj_villkor !== "" ? tvChannelPackage.acf.kampanj_villkor : null,
          channels: tvChannelPackage.acf.tv_kanaler.map((tvChannel) => {
            return tvChannels.find((channel) => (channel.id === tvChannel ? channel : null));
          }),
        })),
      ];

      return tvChannelPackages;
    } catch (error) {
      // Handle error here
      console.error("Error fetching TV channel packages:", error);
      // You can throw the error or return a default value, depending on your use case
      throw error;
    }
  };

  return { getTvChannelPackages };
};

export default useGetTvChannelPackages;
